import React from 'react' 
import Button from '../uiKit/Button'
import ProfilePic from '../ProfilePic'
import {getUserNameForId} from '../../utils/getUserNameForId'
 
class RepoDefaultPreviewPanelMemberListItem extends React.Component{

	render(){
		const {permission, repoId}=this.props
		const user=permission.user || {}		
		const isPending=!permission.joined

		return(
			<div className={'repoDefaultPreviewPanel-memberList-item' + (isPending ? ' repoDefaultPreviewPanel-memberList-item--pending' : '')}>
								
				<ProfilePic size='30' borderRadius='3' user={permission.user || null} />				
				
				<div className='repoDefaultPreviewPanel-memberList-item-labelPrimary'>
					
				
					<React.Fragment>
						{getUserNameForId(user.id,repoId,true)}
					</React.Fragment>
					

					

				</div>

			</div>
			
		)
	}

}
  
       
 
class RepoDefaultPreviewPanel extends React.Component{

	constructor(){
		super()
		this.handleDoubleClick=this.handleDoubleClick.bind(this)
	}

	showUpgrade(){
		window.location.hash='upgrade'
	}

	handleDoubleClick(){
		if(this.props.currentUserPermission.role !== 'viewer'){
			this.props.showInvitationModal()
		}
	}

	render(){
		const {currentUserPermission,permissionsJoined,service,repoId,meta}=this.props

		let product
		if(service){
			product = service.product
		}
		let trialUsed=true
		if(meta){
			trialUsed=meta.trialUsed
		}




		
		return(
			<div className='repoDefaultPreviewPanelContainer'>
				<div className={'repoDefaultPreviewPanel ' + (currentUserPermission && currentUserPermission.role === 'viewer' ? 'repoDefaultPreviewPanel--viewer' : '')} >
					<div className='repoDefaultPreviewPanel-header'>
						{currentUserPermission && currentUserPermission.role !== 'viewer' &&										
							<Button size='large' iconName='sharedLayered' color={product === 'free' ? 'white' : 'blue'} disabled={product === 'free'} label='Invite' onClickFunction={this.props.showInvitationModal}/>
						}
						
						{permissionsJoined && permissionsJoined.length === 0 && product === 'plus' &&
							<div className='repoDefaultPreviewPanel-message'>
								Invite people to add and edit this pack's content together.
							</div>
						}
						{product === 'free' && !trialUsed &&
							<div className='repoDefaultPreviewPanel-message repoDefaultPreviewPanel-message--free' onClick={this.showUpgrade}>
								Try Plickers Pro free for 14 days and invite people to your pack.
							</div>
						}
						{product === 'free' && trialUsed &&
							<div className='repoDefaultPreviewPanel-message repoDefaultPreviewPanel-message--free' onClick={this.showUpgrade}>
								Upgrade to Plickers Pro and invite people to your pack.
							</div>
						}						

					</div>



					{permissionsJoined && permissionsJoined.length > 0 && currentUserPermission && !currentUserPermission.disabled &&
						<div className='repoDefaultPreviewPanel-memberList' onDoubleClick={this.handleDoubleClick}>
							{currentUserPermission &&
								<RepoDefaultPreviewPanelMemberListItem repoId={repoId} currentUser permission={currentUserPermission} />
							}

							{permissionsJoined && permissionsJoined.map((permission,i)=>{
			 					return <RepoDefaultPreviewPanelMemberListItem key={i} permission={permission} repoId={repoId} />
			 				})}
								
						</div>
					}

				</div>
								

			</div>

			
		)
	}

}

       

export default RepoDefaultPreviewPanel



// WEBPACK FOOTER //
// ./src/components/repo/RepoDefaultPreviewPanel.js